export default __webpack_public_path__ + "static/media/ProfileDefault.b46a88bb.svg";